import React from "react";
import { LazyLoadImage } from 'react-lazy-load-image-component';

import { ImageStyled } from "./styled";

type ImageProps = {
    src: string;
    alt: string;
    props?: any;
};

export const ImageCustom = ({ src, alt, props }: ImageProps) => {
    return (
        <ImageStyled>
            <LazyLoadImage
                src={src}
                alt={alt}
                className="hs-image"
                {...props}
            />
        </ImageStyled>
    );
};
